var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-403"},[_vm._m(0),_c('h5',[_vm._v("您的访问受限")]),(_vm.errorInfo)?_c('div',{staticStyle:{"color":"#333","font-size":"0.8rem"}},[_vm._v(" 如需帮助请联系管理员 "),_c('el-button',{staticClass:"ml-1",attrs:{"type":"primary","size":"mini"},on:{"click":_vm.connectAdmin}},[_vm._v("联系")])],1):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h3',[_vm._v("Error "),_c('span',[_vm._v("403")])])
}]

export { render, staticRenderFns }